import React, { useCallback, useContext, useState, useEffect } from 'react';
import {
  AppContext,
  isAuthorised,
  withErrorBoundary,
  getTranslatedText,
  useActivityTracker,
  OPERATORMAP,
  DeleteModal,
  useIntl,
  toast,
  CustomModal,
  useCheckFeatureGating,
  useProduct
} from '@nile/components';
import {
  Button,
  Popover,
  TextStyle,
  Tippy,
  Modal,
  Banner,
  ButtonGroup,
  ActionList
} from '@superops/ui-design-system';
import { withRouter } from 'react-router-dom';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import NewReportShare from '@nile/reports/src/modules/reports/components/subpages/NewReportShare';
import ReportConfiguration from '@nile/reports/src/modules/reports/components/subpages/ReportConfiguration';
import { preFormatFilterObject } from '@nile/reports/src/modules/component/helper';
import { SVGIcon } from '@superops/super-icons';
import {
  DELETE_REPORT,
  DOWNLOAD_PDF_REPORT,
  GET_REPORT_CONFIGURATION
} from '@nile/reports/src/modules/reports/graphql';
import { EXPORT_REPORT } from '@nile/reports/src/modules/DataReports/graphql';
import {
  AccountClient,
  savePersonalization,
  useCachedQuery
} from '@nile/graphql';
import { useMutation, useLazyQuery } from '@apollo/client';
import {
  EDIT_MODE,
  DEFAULT_VIEW,
  PDF_REPORT,
  DATA_REPORT,
  REPORTS,
  EFFICIENCY_REPORT,
  CONFIGURATION_ICON_MAP,
  METRIC_REPORT,
  RETAINER,
  NEWREPORTID,
  INVOICE_STATEMENTS
} from '@nile/reports/src/modules/home/constants';
import DataReportCascade from '@nile/reports/src/modules/DataReports/components/pages/DataReportCascade';
import { FormattedMessage } from 'react-intl';
import { cloneDeep, isEmpty } from 'lodash';
import { SHARE, SCHEDULE } from './constant';
import DownloadHistory from '../DownloadHistory';
import ClientSiteFilter from '../ClientSiteFilter';

function ReportActions(props) {
  const { history, isEditMode, reportType, reportInternalType } = props;
  const intl = useIntl();
  const appContext = useContext(AppContext);
  const reportsContext = useContext(ReportsContext);
  const isMSPProduct = useProduct('MSP');

  const [getClient, setClient] = useState();

  const [getSite, setSite] = useState([]);

  const currentUser = appContext.user;

  const userRole = appContext?.user?.role?.roleFeatureList || [];

  const roleFeatures = currentUser?.role?.roleFeatureList || [];
  const [modalActive, setModalActive] = useState(false);
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedSite, setSelectedSite] = useState('');
  const [agentModalActive, setAgentModalActive] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [configurationModal, setConfigurationModal] = useState(false);
  const [fromModal, setFromModal] = useState(false);
  const [reportConfigMeta, setReportConfigMeta] = useState([]);

  const showConfigurationBtn = !isEmpty(
    reportsContext?.activeReport?.reportConfig
  );

  const toggleAgentModal = useCallback(
    () => setAgentModalActive(!agentModalActive),
    [agentModalActive]
  );
  const user = {
    firstName: currentUser.firstName,
    userId: currentUser.userId,
    email: currentUser.email,
    lastName: currentUser.lastName
  };

  const isEditAuthorised = isAuthorised(userRole, 'report.edit');
  const isDeleteAuthorised = isAuthorised(roleFeatures, 'report.delete');
  const isShareAuthorised = isAuthorised(roleFeatures, 'shareReport.allow');

  const [sheetOpen, setSheetOpen] = useState({
    value: false,
    content: null
  });

  const toggleSheetOpen = (val) => {
    setSheetOpen(val);
  };

  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((active) => !active),
    []
  );

  const [exportModal, openExportModal] = useState(false);

  const [openDataReport, setOpenDataReport] = useState(false);
  const toggleDataReportActive = useCallback(
    () => setOpenDataReport((active) => !active),
    []
  );

  const reportData = reportsContext.activeReport;

  useEffect(() => {
    setSelectedClient(
      reportsContext?.reportCondition[reportsContext?.activeView]?.find(
        (el) => el?.attribute === 'client'
      )
    );

    setSelectedSite(
      reportsContext?.reportCondition[reportsContext?.activeView]?.find(
        (el) => el?.attribute === 'site'
      )
    );
  }, [reportsContext?.reportCondition[reportsContext?.activeView]]);

  const onEdit = () => {
    if (reportType === REPORTS) {
      setPopoverActive(false);
      reportsContext.setReportViewMode(EDIT_MODE);
      return;
    }
    if (reportType === DATA_REPORT) {
      toggleDataReportActive();
    }
  };

  const getMenuActions = () => {
    const menuItems = [];
    if (isEditAuthorised && !isEditMode) {
      menuItems.push({
        name: 'EDIT',
        label: getTranslatedText(intl, 'common.edit'),
        icon: <SVGIcon name="Edit" />,
        action: onEdit
      });
    }

    if (isDeleteAuthorised) {
      menuItems.push({
        name: 'DELETE',
        label: getTranslatedText(intl, 'common.delete'),
        icon: <SVGIcon name="Delete" color="red" />
      });
    }
    return menuItems;
  };

  const menuAction = getMenuActions();

  const personalisation = () => {
    const personalisedData = {
      user: user,
      name: 'reportFilter',
      category: 'REPORTDETAIL',
      value: JSON.stringify({
        reportFilter: reportsContext.reportCondition[reportsContext.activeView]
      })
    };
    savePersonalization({
      variables: personalisedData,
      input: personalisedData
    });
  };

  const trackReport = (trackerdata) => {
    useActivityTracker({
      event: 'DEFAULT_PDF_REPORT_GENERATE',
      data: trackerdata
    });
  };

  const [downloadPdfReport] = useLazyQuery(DOWNLOAD_PDF_REPORT, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    onCompleted(res) {
      trackReport({
        reportName: reportsContext?.activeReport?.name
      });
      setModalActive(false);
      setDownloadBtnLoading(false);
      toast('success', 'reports.pdf.download.initiate');
    },
    onError() {
      toast('error', 'reports.pdf.download.error');
    }
  });

  const trackExportReport = (trackerdata) => {
    useActivityTracker({
      event: 'EXPORT_REPORT_CSV',
      data: trackerdata
    });
  };

  const { loading: pdfConfigLoading } = useCachedQuery(
    GET_REPORT_CONFIGURATION,
    {
      client: AccountClient,
      skip: isEmpty(reportsContext?.activeReport?.reportConfig),
      variables: {
        reportId: reportsContext?.activeReport?.reportId
      },
      onCompleted({ getReportConfigMeta }) {
        setReportConfigMeta(getReportConfigMeta?.metrics);
      }
    }
  );

  const [exportReport] = useLazyQuery(EXPORT_REPORT, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    onCompleted(res) {
      trackExportReport({
        reportName: reportsContext?.activeReport?.name
      });
      setDownloadBtnLoading(false);
      toast('success', 'app.toast.charts.exportCsv.success');
    },
    onError() {
      setDownloadBtnLoading(false);
      toast('error', 'common.error');
    }
  });

  const isClientSelect =
    reportsContext?.reportCondition[reportsContext?.activeView]?.find(
      (el) => el.attribute === 'client'
    )?.value || null;

  const triggerDownloadPdf = () => {
    downloadPdfReport({
      variables: {
        module: 'REPORT',
        type: PDF_REPORT,
        reportId: reportsContext?.activeReport?.reportId,
        filterConditions: isMSPProduct
          ? {
              clientId: getClient?.accountId,
              siteIds: getSite?.id ? [getSite?.id] : [],
              dateCondition: {}
            }
          : {}
      }
    });
    toggleAgentModal();
  };
  /** Download pdf */
  const downloadPdf = () => {
    setDownloadBtnLoading(true);
    triggerDownloadPdf();
  };

  const onClone = () => {
    if (reportType === REPORTS) {
      reportsContext.setCloneId(reportData.reportId);
      history.push(`/report/${NEWREPORTID}/new`);
      return;
    }
    if (reportType === DATA_REPORT) {
      reportsContext.setCloneId(reportData.reportId);
      toggleDataReportActive();
    }
  };

  const exportCsv = async () => {
    setDownloadBtnLoading(true);
    openExportModal(false);
    let variable = {
      reportId: reportsContext?.activeReport?.reportId
    };
    if (reportsContext.reportCondition[reportsContext.activeView]) {
      const { operands, reportCondition } = await preFormatFilterObject({
        entity: reportsContext.activeReport?.entity,
        filterObj: cloneDeep(
          reportsContext.reportFilter?.current &&
            reportsContext.reportFilter?.current?.[reportsContext.activeView]
        )
      });
      variable = {
        ...variable,
        condition:
          (!isEmpty(reportCondition) &&
            !isEmpty(operands) && {
              joinOperator: 'AND',
              operands
            }) ||
          null
      };
    }
    useActivityTracker({
      event: 'DATA_REPORT_EXPORT_CSV',
      data: {
        reportId: reportsContext?.activeReport?.reportId,
        reportName: reportsContext?.activeReport?.name
      }
    });
    exportReport({
      variables: {
        ExportReportIdentifierInput: variable
      }
    });
  };

  const getActions = () => {
    const actionItems = [];
    const showDownloadBtn =
      reportType === PDF_REPORT || reportType === DATA_REPORT;
    const showExport =
      reportType === REPORTS &&
      reportInternalType !== RETAINER &&
      reportInternalType !== INVOICE_STATEMENTS;

    const showHistory = reportType === DATA_REPORT;
    const isScheduleReportAvailable =
      useCheckFeatureGating('SCHEDULE_REPORTS')?.enabled &&
      reportInternalType !== RETAINER &&
      reportInternalType !== INVOICE_STATEMENTS;
    const SHOW_SHARE_SCHEDULE = reportType !== EFFICIENCY_REPORT;

    const showClone =
      useCheckFeatureGating('CUSTOM_REPORTS')?.enabled &&
      !isEditMode &&
      reportType !== PDF_REPORT &&
      reportType !== EFFICIENCY_REPORT &&
      reportInternalType !== RETAINER &&
      reportInternalType !== INVOICE_STATEMENTS;

    if (showConfigurationBtn) {
      actionItems.push({
        name: 'CONFIGURATION',
        label: getTranslatedText(intl, 'common.label.configure'),
        icon: <SVGIcon name="Configuration" />,
        action: () => setConfigurationModal(true)
      });
    }

    if (showClone) {
      actionItems.push({
        name: 'CLONE',
        label: getTranslatedText(intl, 'common.clone'),
        icon: <SVGIcon name="Clone" />,
        action: onClone
      });
    }
    if (showExport) {
      actionItems.push({
        name: 'EXPORT',
        label: getTranslatedText(intl, 'reports.report.header.download.button'),
        icon: <SVGIcon name="Download" />,
        action: () => {
          personalisation();
          useActivityTracker({
            event: 'EXPORT_REPORT_PDF',
            data: {
              reportName: reportData?.name,
              reportId: reportData?.reportId
            }
          });
          window
            .open(`#/export/report/${reportData.reportId}`, '_blank')
            .focus();
        }
      });
    }
    if (showHistory) {
      actionItems.push({
        name: 'HISTORY',
        label: getTranslatedText(
          intl,
          'reports.report.header.download.history.button'
        ),
        action: () => setOpenHistory(true),
        icon: <SVGIcon name="HistoryIcon" />
      });
    }

    if (SHOW_SHARE_SCHEDULE) {
      if (isScheduleReportAvailable) {
        actionItems.push({
          name: 'SCHEDULE',
          label: getTranslatedText(
            intl,
            'reports.report.header.schedule.share.button'
          ),
          action: () => {
            useActivityTracker({
              event: 'SCHEDULE_REPORT',
              data: {
                reportName: reportData?.name,
                reportId: reportData?.reportId
              }
            });
            toggleSheetOpen({
              value: true,
              content: SCHEDULE
            });
          },
          icon: <SVGIcon name="DatePicker" />
        });
      }

      if (isShareAuthorised) {
        actionItems.push({
          name: 'SHARE',
          label: getTranslatedText(intl, 'reports.report.header.share.button'),
          action: () => {
            useActivityTracker({
              event: 'SHARE_REPORT',
              data: {
                reportName: reportData?.name,
                reportId: reportData?.reportId
              }
            });
            toggleSheetOpen({
              value: true,
              content: SHARE
            });
          },
          icon: <SVGIcon name="Share" />
        });
      }
    }

    if (showDownloadBtn) {
      actionItems.push({
        name: 'DOWNLOAD',
        label: getTranslatedText(intl, 'common.download'),
        action: () => {
          setModalActive(true);
        },
        icon: <SVGIcon name="Share" />,
        tippyInfo: getTranslatedText(
          intl,
          'reports.select.client.to.download.info'
        )
      });
    }

    return actionItems;
  };

  const actions = getActions();

  const [deleteReport] = useMutation(DELETE_REPORT, {
    client: AccountClient,
    onCompleted(res) {
      /* Close sheet container once an employee created */
      if (res?.deleteReport) {
        toast(
          'success',
          reportType === REPORTS
            ? 'reports.create.deleteDashboard.success'
            : 'reports.create.deleteDatareport.success'
        );
        reportsContext.getAllReports();
      }
    }
  });

  const handleReportDeletion = (id) => {
    deleteReport({
      variables: {
        reportId: id
      }
    });
  };

  const handleModalClose = () => {
    setDownloadBtnLoading(false);
    setModalActive(false);
  };

  const getUnit = (currentEle, selectedAttr) => {
    switch (selectedAttr?.input?.thresholdUnit?.type) {
      case 'staticText':
        return selectedAttr?.input?.thresholdUnit?.label;
      case 'select':
        return selectedAttr?.input?.thresholdUnit?.choices?.find(
          (lab) => lab?.value === currentEle?.condition?.value?.unit
        )?.label;
      default:
        return '';
    }
  };

  const getContentText = (metric) => {
    const FREE_TEXT = ['ramSpace'];
    const TOTAL_TEXT = ['diskSpace'];
    if (FREE_TEXT.includes(metric)) return 'free';
    if (TOTAL_TEXT.includes(metric)) return 'total';
    return 'free';
  };

  const getInfoContent = () => {
    const operatorMap = OPERATORMAP(intl);
    switch (reportData?.reportId) {
      default:
        return (
          <div className="mt10">
            {reportData?.reportConfig?.metrics
              ?.filter((el) => !isEmpty(el?.condition) && el?.enabled)
              ?.map((el) => {
                const selectedAttr = reportConfigMeta?.find(
                  (ele) => ele?.metric === el?.condition?.attribute
                );
                const unit = getUnit(el, selectedAttr);
                if (!selectedAttr) {
                  return <></>;
                }
                return (
                  <div className="fx mb10">
                    <div className="fx actr mr8">
                      <SVGIcon
                        name={CONFIGURATION_ICON_MAP[selectedAttr?.metric]}
                        size="sm"
                      />
                    </div>
                    {`If ${getContentText(
                      selectedAttr?.metric
                    )} ${getTranslatedText(
                      intl,
                      selectedAttr?.label || ''
                    )} on device
                    goes ${operatorMap?.[el?.condition?.operator]} `}
                    <div className="ml4">
                      <TextStyle weight="Bold">
                        {el?.condition?.value?.data}
                      </TextStyle>
                    </div>
                    <div className="mlr5">
                      <TextStyle weight="Bold">{unit}</TextStyle>
                    </div>
                    then marked as
                    <span className="ml4">
                      <TextStyle weight="Bold">Failed</TextStyle>
                    </span>
                  </div>
                );
              })}
          </div>
        );
    }
  };

  const getActionContent = (action) => {
    switch (action.name) {
      case 'EXPORT':
      case 'SHARE':
      case 'SCHEDULE':
      case 'HISTORY':
      case 'CLONE':
      case 'CONFIGURATION':
        return (
          <Tippy interactive title={action.label} position="bottom-end">
            <Button onClick={action.action} icon={action.icon} />
          </Tippy>
        );
      case 'DELETE':
        return (
          <DeleteModal
            modalActivator={
              <div className="flex center ptr">
                {action.icon}
                <div className="ml8">
                  <TextStyle variation="negative">{action.label}</TextStyle>
                </div>
              </div>
            }
            sectioned={false}
            description={
              <div className="mbt15">
                {getTranslatedText(
                  intl,
                  reportType === REPORTS
                    ? 'reports.dashboard.deleteItem.modalDescription'
                    : 'reports.datareport.deleteItem.modalDescription'
                )}
              </div>
            }
            handleDeleteConfirmation={() =>
              handleReportDeletion(reportData.reportId)
            }
            title={getTranslatedText(
              intl,
              reportType === REPORTS
                ? 'reports.dashboard.deleteItem.title'
                : 'reports.datareport.deleteItem.title'
            )}
            variant="confirmation"
          />
        );
      case 'DOWNLOAD':
        return (
          <>
            <div className="fx g10">
              {reportType === DATA_REPORT && (
                <Modal
                  activator={
                    <Tippy
                      interactive
                      title={getTranslatedText(intl, 'common.exportCsv')}
                      position="bottom-end"
                    >
                      <Button
                        primary
                        onClick={() => openExportModal(true)}
                        loading={downloadBtnLoading}
                        icon={<SVGIcon name="Download" />}
                      >
                        <FormattedMessage id="common.exportCsv" />
                      </Button>
                    </Tippy>
                  }
                  open={exportModal}
                  onClose={() => openExportModal(false)}
                  variant="confirmation"
                  title={<FormattedMessage id="common.exportCsv" />}
                  primaryAction={{
                    content: (
                      <div className="flex actr">
                        <SVGIcon name="CircleTickOutlineMinor" />
                        <div className="ml8">
                          <FormattedMessage id="invoice.details.list.taxable" />
                        </div>
                      </div>
                    ),
                    onAction: exportCsv
                  }}
                  secondaryActions={[
                    {
                      content: <FormattedMessage id="common.cancel" />,
                      onAction: () => openExportModal(false)
                    }
                  ]}
                >
                  <FormattedMessage id="reports.datareport.exportCsv.modal.description" />
                </Modal>
              )}

              {reportType === PDF_REPORT && isMSPProduct && (
                <>
                  <Button
                    primary
                    onClick={toggleAgentModal}
                    icon={<SVGIcon name="Add" color="white" />}
                  >
                    <FormattedMessage id="common.create" />
                  </Button>

                  <div className="fx g10">
                    <Modal
                      open={agentModalActive}
                      onClose={toggleAgentModal}
                      showCloseButton={false}
                      medium
                      title={
                        <div className="fx actr">
                          {getTranslatedText(
                            intl,
                            'report.generate.pdf.report.heading'
                          )}
                          <div className="fx f21 jend">
                            <ButtonGroup spacing="loose">
                              <Button
                                onClick={() => toggleAgentModal()}
                                plainSecondary
                              >
                                <FormattedMessage id="common.cancel" />
                              </Button>
                              <Button
                                disabled={!getClient}
                                primary
                                onClick={downloadPdf}
                                icon={<SVGIcon name="CircleTickOutlineMinor" />}
                              >
                                <FormattedMessage id="client.details.contractinvoice.generate" />
                              </Button>
                            </ButtonGroup>
                          </div>
                        </div>
                      }
                    >
                      <ClientSiteFilter
                        hideAgent
                        removeWhiteSpace
                        clientGet={setClient}
                        siteGet={setSite}
                      />
                      <div className="m10">
                        <Banner status="info">
                          <div>
                            <span className="pl3">
                              <FormattedMessage id="common.the" />
                            </span>
                            <span className="bold pl3">
                              {reportsContext?.activeReport?.name}
                            </span>
                            <span className="pl3">
                              <FormattedMessage id="common.pdf.file.send.info" />
                            </span>
                          </div>
                        </Banner>
                      </div>
                      {!isEmpty(reportData?.reportConfig) && !pdfConfigLoading && (
                        <div className="m10">
                          <Banner hideIcon>
                            <div className="fx">
                              <TextStyle weight="bold">
                                <FormattedMessage id="reports.report.asset.health.config.title" />
                              </TextStyle>
                              <div className="fx fx2 jend">
                                <Button
                                  plain
                                  onClick={() => {
                                    toggleAgentModal();
                                    setConfigurationModal(true);
                                    setFromModal(true);
                                  }}
                                >
                                  <FormattedMessage id="app.btn.modify" />
                                </Button>
                              </div>
                            </div>
                            <div>{getInfoContent()}</div>
                          </Banner>
                        </div>
                      )}
                    </Modal>

                    {isClientSelect && (
                      <Modal
                        open={modalActive}
                        onClose={handleModalClose}
                        variant="confirmation"
                        title={<FormattedMessage id="common.pdf.processing" />}
                        primaryAction={{
                          content: (
                            <div className="flex actr">
                              <SVGIcon name="CircleTickOutlineMinor" />
                              <div className="ml8">
                                <FormattedMessage id="common.yes" />
                              </div>
                            </div>
                          ),
                          onAction: downloadPdf
                        }}
                        secondaryActions={[
                          {
                            content: <FormattedMessage id="common.cancel" />,
                            onAction: () => handleModalClose()
                          }
                        ]}
                      >
                        <div className="pt10">
                          <span className="bold">
                            {reportsContext?.activeReport?.name}
                          </span>
                          <span className="pl3">
                            <FormattedMessage id="pdfreport.generate.for" />
                          </span>
                          <span className="bold pl3">
                            {selectedClient?.label}
                          </span>
                          {selectedSite && (
                            <span className="pl3">
                              <FormattedMessage id="pdfreport.and.site" />
                              <span className="bold pl3">
                                {selectedSite?.label}
                              </span>
                            </span>
                          )}
                          <span className="pl3">
                            <FormattedMessage id="common.pdf.file.send.info" />
                          </span>
                        </div>
                      </Modal>
                    )}
                  </div>
                </>
              )}
              {reportType === PDF_REPORT && !isMSPProduct && (
                <Button
                  disabled={downloadBtnLoading}
                  primary
                  onClick={downloadPdf}
                  icon={<SVGIcon name="CircleTickOutlineMinor" />}
                >
                  <FormattedMessage id="client.details.contractinvoice.generate" />
                </Button>
              )}
            </div>
          </>
        );
      default:
        return (
          <div onClick={action.action} className="flex center ptr">
            {action.icon}
            <div className="ml8">{action.label}</div>
          </div>
        );
    }
  };

  return (
    <>
      <div className="fx g10">
        {isEditAuthorised && (
          <>
            <div className="fx g10 p8">
              {!isEditMode &&
                reportsContext.activeView !== DEFAULT_VIEW &&
                reportType !== PDF_REPORT && (
                  <div className="fx actr">
                    <Popover
                      active={popoverActive}
                      activator={
                        <Button
                          icon={<SVGIcon name="Menu" />}
                          onClick={togglePopoverActive}
                        />
                      }
                      preferredAlignment="right"
                      onClose={togglePopoverActive}
                    >
                      <ActionList
                        actionRole="menuItem"
                        items={menuAction.map((el) => ({
                          content: getActionContent(el)
                        }))}
                      />
                    </Popover>
                  </div>
                )}
              {actions.map((el) => getActionContent(el))}
            </div>

            {configurationModal && (
              <CustomModal
                locked
                open
                onClose={() => setConfigurationModal(false)}
              >
                <ReportConfiguration
                  callBack={() => {
                    setConfigurationModal(false);
                    if (fromModal) {
                      setFromModal(false);
                      toggleAgentModal();
                    }
                  }}
                  data={reportsContext.activeReport}
                  fromModal={fromModal}
                />
              </CustomModal>
            )}

            {openHistory && (
              <DownloadHistory
                callBack={() => setOpenHistory(false)}
                data={reportsContext.activeReport}
              />
            )}
            {reportData?.reportId && sheetOpen.value && (
              <NewReportShare
                data={reportsContext.activeReport}
                toggleSheetOpen={toggleSheetOpen}
                sheetOpen={sheetOpen}
                isScheduled={sheetOpen.content === SCHEDULE}
              />
            )}
            {reportData?.reportId && openDataReport && (
              <DataReportCascade
                callBack={toggleDataReportActive}
                mode="edit"
                report={reportData}
              />
            )}
          </>
        )}
      </div>
    </>
  );
}

export default withRouter(withErrorBoundary(ReportActions));
